import React from 'react';

import css from './SectionInfo.module.css';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../../../components';
import leftImage from './images/left.png'
import rightImage from './images/right.png'
import bottomImage from './images/bottom.png'


const SectionInfo = props => {

    return (
        <div className={css.root}>

            <div className={css.cardWrapper}>
                <div className={css.horizontalWrapper}>
                    <div className={css.verticalWrapper}>

                        <p className={css.title}>
                            <FormattedMessage id="LandingProfessionalsPage.SectionInfo.section1.title" />
                        </p>

                        <p className={css.info}>
                            <FormattedMessage id="LandingProfessionalsPage.SectionInfo.section1.info" />
                        </p>

                        <Button>
                            <FormattedMessage id="LandingProfessionalsPage.SectionInfo.section1.button" />
                        </Button>
                    </div>
                    <img className={css.image} src={rightImage} />
                </div>


                <div className={css.horizontalWrapper}>

                    <img className={css.image} src={leftImage} />

                    <div className={css.verticalWrapper}>

                        <p className={css.title}>
                            <FormattedMessage id="LandingProfessionalsPage.SectionInfo.section2.title" />
                        </p>

                        <p className={css.info}>
                            <FormattedMessage id="LandingProfessionalsPage.SectionInfo.section2.info" />
                        </p>

                        <Button>
                            <FormattedMessage id="LandingProfessionalsPage.SectionInfo.section2.button" />
                        </Button>
                    </div>
                </div>
            </div>

            <div className={css.cardWrapper}>
                <div className={css.horizontalWrapper}>
                    <div className={css.verticalWrapper}>

                        <p className={css.title}>
                            <FormattedMessage id="LandingProfessionalsPage.SectionInfo.section3.title" />
                        </p>

                        <p className={css.info}>
                            <FormattedMessage id="LandingProfessionalsPage.SectionInfo.section3.info" />
                        </p>

                        <Button>
                            <FormattedMessage id="LandingProfessionalsPage.SectionInfo.section3.button" />
                        </Button>
                    </div>
                    <img className={css.imageRounded} src={bottomImage} />
                </div>
            </div>

        </div>
    );
};

export default SectionInfo;
